import React from 'react';
import '@/util/dayjsInit';
import dayjs from 'dayjs';
import {getFileUrl} from '@/page/util/appUrlUtils';
import {Image, Card} from 'antd';
import ReactPlayer from 'react-player';
import styles from './card.module.less';
import FileCard from '@/page/conversation/ConPage/FileCard';
import MeetingCard from '@/page/conversation/ConPage/MeetingCard';
import MixCard from '@/page/conversation/ConPage/MixCard';
import LocationCard from '@/page/conversation/ConPage/LocationCard';
import LinkCard from '@/page/conversation/ConPage/LinkCard';
import RedPacket from '@/page/conversation/ConPage/RedPacket';
import VoiceCard from '@/page/conversation/ConPage/VoiceCard';
import UserCard from '@/page/conversation/ConPage/UserCard';
import WeappCard from '@/page/conversation/ConPage/WeappCard';
import SphfeedCard from '@/page/conversation/ConPage/SphfeedCard';

const {Meta} = Card;

/**
 * 为聊天页面准备的数据重组
 * @param content
 * @param sendInfo
 * @param receiveInfo
 * @param fromType
 * @returns {{contentTemp: (JSX.Element|string), name, avatar, time, type: number, content}}
 */
export function judge(content, sendInfo, receiveInfo, fromType) {
    let {from, msgtime} = content;
    let extId;
    extId = fromType === 0 ? sendInfo.extId : sendInfo.externalUserId;
    let contentTemp;
    let name;
    let avatar;
    let type;
    let time = dayjs(parseInt(msgtime)).format('YYYY-MM-DD HH:mm:ss');
    if (extId === from) {
        name = sendInfo.name;
        avatar = sendInfo.avatar;
        type = 1;
    } else {
        name = receiveInfo.name;
        avatar = receiveInfo.avatar;
        type = 0;
    }
    contentTemp = switchMsgType(content, name);
    return {name, avatar, contentTemp, type, time, content};
}

/**
 * 根据传入内容判断显示(聊天用)
 * @param content
 * @returns {JSX.Element|string}
 */
function switchMsgType(content, name) {
    let {msgtype} = content;
    let contentTemp;
    console.log('content', content)
    switch (msgtype) {
        case 'text':
            contentTemp = content.text.content;
            break;
        case 'chatRecord':
            contentTemp = (
                <Card hoverable bordered={false}>
                    <Meta
                        title={
                            <span style={{fontSize: '14px', fontWeight: '400'}}>
                                {content.chatRecord.title + '聊天记录'}
                            </span>
                        }
                    />
                </Card>
            );
            break;
        case 'external_redpacket':
            contentTemp = <RedPacket packet={content.redPacket} />;
            break;
        case 'redpacket':
            contentTemp = <RedPacket packet={content.redPacket} />;
            break;
        case 'image':
            contentTemp = (
                <div className={styles.img}>
                    <Image
                        src={getFileUrl(content.image.attachment, content.image.attachmentext)}
                        alt=""
                        width={200}
                        fallback="data:image/png;base64,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"
                    />
                </div>
            );
            break;
        case 'file':
            const fileUrl = getFileUrl(content.file.attachment, content.file.attachmentext);
            contentTemp = <FileCard url={fileUrl} title={content.file.filename} />;
            break;
        case 'voice':
            const voiceUrl = getFileUrl(content.voice.attachment, content.voice.attachmentext);
            contentTemp = <VoiceCard url={voiceUrl} />;
            break;
        case 'video':
            const videoUrl = getFileUrl(content.video.attachment, content.video.attachmentext);
            contentTemp = (
                <ReactPlayer controls playing={false} url={videoUrl} width="100%" height={200} />
            );
            break;
        case 'mixed': {
            contentTemp = <MixCard mixed={content.mixed.item} />;
            break;
        }
        case 'card': {
            let {
                card: {corpname, userid},
            } = content;
            contentTemp = <UserCard userId={userid} corpName={corpname} />;
            break;
        }
        case 'revoke': {
            contentTemp = (
                <div>
                    <p className={styles.revoke}>{"'" + name + "' 撤回一条消息"}</p>
                    {switchMsgType(content.premsg)}
                </div>
            );
            break;
        }
        case 'emotion': {
            contentTemp = (
                <div className={styles.img}>
                    <Image
                        src={getFileUrl(content.emotion.attachment, content.emotion.attachmentext)}
                        alt=""
                        width={200}
                        fallback="data:image/png;base64,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"
                    />
                </div>
            );
            break;
        }
        case 'link': {
            contentTemp = <LinkCard link={content.link} />;
            break;
        }
        case 'docmsg': {
            contentTemp = <FileCard url={content.doc.linkurl} title={content.doc.title} />;
            break;
        }
        case 'location': {
            contentTemp = (
                <LocationCard title={content.location.title} address={content.location.address} />
            );
            break;
        }
        case 'meeting': {
            contentTemp = <MeetingCard meeting={content.meeting} />;
            break;
        }
        case 'meeting_voice_call': {
            const voiceUrl = getFileUrl(
                content.meetingVoiceCall.attachment,
                content.meetingVoiceCall.attachmentext
            );
            const {docShare} = content;
            contentTemp = (
                <FileCard url={voiceUrl} title={'语音会议'} isFile={false} docShare={docShare} />
            );
            break;
        }
        case 'voip_doc_share': {
            // contentTemp = '[语音会议文件分享]';
            contentTemp = <FileCard title={content.voipDocShare.filename} />;
            break;
        }
        case 'weapp': {
            // contentTemp = '[语音会议文件分享]';
            contentTemp = <WeappCard weapp={content.weApp} />;
            break;
        }
        case 'sphfeed': {
            // contentTemp = '[语音会议文件分享]';
            contentTemp = <SphfeedCard sphfeed={content.sphfeed} />;
            break;
        }
        case 'markdown': {
            // contentTemp = '[语音会议文件分享]';
            contentTemp = content.info.content;
            break;
        }
        case 'agree': {
            // contentTemp = '[语音会议文件分享]';
            contentTemp = '[同意会话存档]';
            break;
        }
        case 'disagree': {
            // contentTemp = '[语音会议文件分享]';
            contentTemp = '[拒绝会话存档]';
            break;
        }
        default: {
            contentTemp = '[暂不支持此类消息]';
            break;
        }
    }
    return contentTemp;
}

export function switchChatRecord(record) {
    let switchContent = {};
    console.log('record', record)
    const {type, mixContent, defaultContent, content} = record;
    const switchType = type.substr(10).toLowerCase();
    if (type === 'ChatRecordMixed') {
        switchContent.msgtype = switchType;
        switchContent[switchType] = {
            item: mixContent,
        };
    } else if (
        type === 'ChatRecordImage' ||
        type === 'ChatRecordVideo' ||
        type === 'ChatRecordFile'
    ) {
        const val = JSON.parse(content);
        console.log('val', val)
        console.log('type', type)
        console.log('switchType', switchType)
        switchContent.msgtype = switchType;
        switchContent[switchType] = val;
    } else if (
        type === 'ChatRecordText'
    ) {
        const val = JSON.parse(defaultContent);
        console.log('val', val)
        console.log('type', type)
        console.log('switchType', switchType)
        switchContent.msgtype = switchType;
        switchContent[switchType] = val;
    } else if (type === 'chatRecord') {
        const val = JSON.parse(content);
        switchContent.msgtype = 'chatRecord';
        val.title = '聊天记录';
        switchContent['chatRecord'] = val;
    } else {
        const val = JSON.parse(defaultContent);
        switchContent.msgtype = switchType;
        switchContent[switchType] = val;
    }
    let temp = switchMsgType(switchContent);
    return {temp, switchContent};
}
